import { ISGSettings, ISGTrackData } from './SDK';
import { IMediaParams } from './SDKmessages';
import { IFBFriend } from './SDKfb';
import { IRewardItem } from '../State/reducers/score';
import { getIsWeb, deviceIsTablet } from '../Utils/Platform';
import ContextPlayer = FBInstant.ContextPlayer;
import { ISDKpayments } from './ISDKpayments';
import { SDKlocalpayments } from './SDKlocalpayments';

export enum ErrorHandlerOptions {
    Fallback = 'fallback',
    Warn = 'warn',
    Throw = 'throw',
}

export interface ILocalSharePayload {
    intent: string;
    image: string;
    text: string;
    data: any;
    surface?: string;
    media?: IMediaParams;
}

export const defaultFriend: IFBFriend = {
    userId: null,
    name: 'friend',
    avatar: 'mapui/no-avatar',
};

export const defaultContextPlayer: ContextPlayer = {
    getID(): string {
        return defaultFriend.userId;
    },
    getPhoto(): string {
        return defaultFriend.avatar;
    },
    getName(): string {
        return defaultFriend.name;
    },
};

export class SDKnetwork {
    public readonly payments: ISDKpayments;
    // @ts-ignore
    private sdkSettings: ISGSettings;
    private sdkHandler: any;

    constructor(sgSettings: any, sdkHandler: any) {
        this.sdkHandler = sdkHandler;
        this.payments = new SDKlocalpayments(false);
        this.sdkSettings = {
            abTesting: {},
            bannerUrl: {},
            crossPromotion: {
                enabled: false,
            },
            env: {
                type: 'local',
                locale: sgSettings.env.locale,
                anotherTab: false,
            },
            game: {
                id: 'moji',
                slug: 'moji',
            },
            invite: {
                native: false,
            },
            moreGames: {
                displayButton: false,
            },
            purchase: {
                available: false,
                native: false,
            },
            rewarded: {
                enabled: true,
            },
            share: {
                native: false,
            },
        };
        console.log(this.sdkSettings);
    }

    // @ts-ignore
    public getLocale() {
        return this.sdkSettings.env.locale;
    }

    // @ts-ignore
    public showLoadProgress(prog: number) {
        try {
            this.sdkHandler.trigger('loading.update', {
                progressPercentage: prog,
            });
        } catch (error) {
            this.handleError('updateLoadingProgress', ErrorHandlerOptions.Warn, undefined, error);
        }
    }

    public async loadComplete() {
        try {
            const self = this;
            return await new Promise(
                (resolve: any, reject: any): any => {
                    self.sdkHandler.trigger('loading.completed', {
                        callback: (err: any, userData: any): any => {
                            resolve({
                                name: 'me',
                                avatar: 'no avatar',
                                userId: '111111199999999999999',
                            });
                        },
                    });
                }
            );
        } catch (error) {
            return this.handleError('finishedLoading', ErrorHandlerOptions.Throw, undefined, error);
        }
    }

    public async retrieveData(key: string): Promise<any> {
        try {
            return await new Promise(
                (resolve: any, reject: any): any => {
                    console.log('###RESTORE', key);
                    this.sdkHandler.trigger('restore', {
                        key: key,
                        callback: (error: any, result: any): any => {
                            if (result) {
                                resolve(JSON.parse(result));
                            } else {
                                resolve(null);
                            }
                        },
                    });
                }
            );
        } catch (error) {
            return this.handleError('finishedLoading', ErrorHandlerOptions.Throw, undefined, error);
        }
    }

    public async storeData(key: string, value: any) {
        try {
            value = JSON.stringify(value);
            console.log('##SAVE', key); // tslint:disable-line
            await new Promise(
                (resolve: any, reject: any): any => {
                    this.sdkHandler.trigger('save', {
                        key: key,
                        value: value,
                        callback: (): any => {}, // tslint:disable-line
                    });
                    resolve();
                }
            );
            return true;
        } catch (error) {
            return this.handleError('save', ErrorHandlerOptions.Warn, false, error);
        }
    }

    public async getRandomFriend() {
        return defaultFriend;
    }

    public getContextPlayers(): ContextPlayer[] {
        return [defaultContextPlayer];
    }

    public async getAd(placement: string): Promise<string> {
        return new Promise(
            (resolve: (result: string) => void): void => {
                resolve('Ad Loaded');
            }
        ).catch(
            (error: any): any => {
                return this.handleError('loadRewardedAd', ErrorHandlerOptions.Warn, false, error);
            }
        );
    }

    public async showAd(instance: any) {
        return new Promise(
            (resolve: (result: boolean) => void): void => {
                this.sdkHandler.trigger('rewardedAd', { callback: resolve });
            }
        ).catch(
            (error: any): any => {
                return this.handleError(
                    'showInterstitialAd',
                    ErrorHandlerOptions.Warn,
                    false,
                    error
                );
            }
        );
    }

    public async getFriends(): Promise<any> {
        return new Promise(resolve => {
            resolve('');
        });
    }
    public async showLoadedAd(): Promise<any> {
        return new Promise(
            (resolve, reject): void => {
                const callback = (showed: boolean) => {
                    if (showed) resolve();
                    else reject();
                };
                this.sdkHandler.trigger('rewardedAd', { callback });
            }
        );
    }

    public async beforePlayButtonDisplay(callback: () => void): Promise<any> {
        try {
            this.sdkHandler.trigger(
                'beforePlayButtonDisplay',
                {
                    callback: callback,
                },
                this
            );
        } catch (error) {
            this.handleError('beforePlayButtonDisplay', ErrorHandlerOptions.Warn, undefined, error);
        }
    }

    public async playButtonPressed(callback: () => void): Promise<void> {
        try {
            this.sdkHandler.trigger(
                'playButtonPressed',
                {
                    callback: callback,
                },
                this
            );
        } catch (error) {
            this.handleError('playButtonPressed', ErrorHandlerOptions.Warn, undefined, error);
        }
    }

    public async askFriend(friend: IFBFriend, item: IRewardItem): Promise<any> {
        return true;
    }

    public getRewardedEnabled() {
        return this.sdkSettings.rewarded.enabled;
    }

    public async getLeaderBoardData(): Promise<any> {
        return new Promise(resolve => {
            resolve([]);
        });
    }

    public async setLeaderBoardData(): Promise<any> {
        return new Promise(resolve => {
            resolve('');
        });
    }

    public async canSubscribeBots() {
        return new Promise(resolve => {
            resolve('');
        });
    }

    public async subscribeBots() {
        return new Promise(resolve => {
            resolve('');
        });
    }

    public async canCreateShortcut() {
        return new Promise(resolve => {
            resolve(false);
        });
    }

    public async createShortcut() {
        return new Promise(resolve => {
            resolve('');
        });
    }

    public async share(sharePayload: ILocalSharePayload) {
        return new Promise(resolve => {
            resolve('');
        });
    }

    public async sendCustomMessage() {}

    public async gameTracking(trackData: ISGTrackData) {
        return Promise.resolve('no tracking on local');
    }

    public async levelStart(level: number) {
        try {
            this.sdkHandler.trigger('levelStart', { level: level });
        } catch (error) {
            this.handleError('startLevel', ErrorHandlerOptions.Warn, undefined, error);
        }
    }

    public async levelEnd(level: number, score: number, state: string) {        
        return new Promise((resolve) => {
            try {
                this.sdkHandler.trigger('levelFinish', {
                    level: level,
                    score: score,
                    state: state,
                    callback: function() { 
                        resolve() 
                    }
                });
            } catch (error) {
                this.handleError('finishLevel', ErrorHandlerOptions.Warn, undefined, error);
            }
        })
    }

    public getPlatform(): string {
        if (getIsWeb() || deviceIsTablet()) {
            return 'WEB';
        }

        return 'MOBILE_WEB';
    }

    public async getEntryPointData() {
        return Promise.resolve('entry on local');
    }

    /* public checkConnection() {
  return false;
} */
    public canSwitchGame() {
        return false;
    }

    private handleError<T, K = any>(
        methodName: string,
        errorBehaviour: ErrorHandlerOptions,
        errorFallbackValue: T,
        error: K
    ): T {
        if (errorBehaviour === ErrorHandlerOptions.Fallback) {
            return errorFallbackValue;
        } else if (errorBehaviour === ErrorHandlerOptions.Warn) {
            // tslint:disable-next-line:no-console
            console.warn(`SDKWrapper::${methodName}`, error);
            return errorFallbackValue;
        } else {
            throw error;
        }
    }
}
